import { useContext } from 'react';

import { firestoreInstance } from '../factory';
import { FirebaseContext } from '../FirebaseProvider';

export const useFirestore = () => {
  const context = useContext(FirebaseContext);

  if (context === null) {
    throw new Error('useFirestore must be used within a FirebaseProvider');
  }

  return { firestore: firestoreInstance || undefined };
};
